


























import { DateUtils } from "../utils/DateUtils";
import { EmployeApi } from "../api/EmployeApi";
import Dropdown from "../core/UI/Dropdown.vue";

export default {
    name: "FraisAttachments",
    components: { Dropdown },
    props: {
        employeId: Number,
        selectedMonth: DateUtils.Month,
    },
    data() {
        return {
            noteDeFrais: null,
            selectedEmployeId: null,
            EmployeApi: new EmployeApi(),
        };
    },
    created() {
        this.selectedEmployeId = this.employeId;
        this.getNoteDeFrais();
    },
    methods: {
        getNoteDeFrais() {
            let self = this;
            if (!self.selectedEmployeId || !self.selectedMonth) {
                return;
            }
            self.EmployeApi.getNoteDeFrais(
                self.selectedEmployeId,
                self.selectedMonth
            )
                .then(function (noteDeFrais) {
                    return (self.noteDeFrais = noteDeFrais);
                })
                .catch(function (error) {
                    return (self.noteDeFrais = null);
                });
        },
        humanReadableDate(str: string) {
            return DateUtils.sqlToDateStr(str);
        },
    },
    watch: {
        selectedMonth: "getNoteDeFrais",
    },
};
